import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const splashScreenActions = createActionGroup({
  source: 'splashScreen',
  events: {
    Show: emptyProps(),
    Hide: emptyProps(),
  },
});
